// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Kx-z","contentClass":"Lx-z","active":"Mx-z","unknown":"Nx-z","leftArrow":"Ox-z","rightArrow":"Px-z","hasArrows":"Qx-z"};